import { render, staticRenderFns } from "./RemoveBlockModal.vue?vue&type=template&id=729443ee&scoped=true"
import script from "./RemoveBlockModal.vue?vue&type=script&lang=js"
export * from "./RemoveBlockModal.vue?vue&type=script&lang=js"
import style0 from "./RemoveBlockModal.vue?vue&type=style&index=0&id=729443ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "729443ee",
  null
  
)

export default component.exports